export enum ContactResponse {
  Success = "success",
  Error = "error",
}

export type ContactResponseState = ContactResponse | undefined;
